export default __webpack_public_path__ + "static/media/no_data_found_calander.c9478bf2.svg";